module.exports = __webpack_public_path__ + "da7a70f46a9de915c25210b66a159dc1.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/owlidays-cup.png
// module id = 2413
// module chunks = 0